'use client';

import React from 'react';
import Sidebar from '@/components/organisms/sidebar';
import { useTranslations } from 'use-intl';
import useItems from './hooks/useItems';
import { DashboardProps } from './types';
import Typography from '@/components/atoms/typography';
import Select from '@/components/atoms/select';

const Dashboard = ({ title, href, children, userName }: React.PropsWithChildren<DashboardProps>) => {
  const translate = useTranslations();
  const { sidebarItems } = useItems();

  return (
    <div className="bg-[#F3EDE9] px-4 pt-10 lg:px-10 dashboard !pb-6">
      <Typography className="hidden !text-32 !font-medium !leading-9 text-[#000000] lg:block">
        My Account
      </Typography>
      <div className={`relative mt-10 items-start gap-4 ${href?.includes('project-builder') ? 'xl:flex' : 'lg:flex '}`}>
        <div className={`${href?.includes('project-builder') ? 'xl:block' : 'lg:block 2xl:block'} sticky top-[100px] hidden w-max shrink-0`}>
          <div className="h-full w-fit bg-[#FFFFFF] px-4 py-8 lg:w-[280px]">
            <Sidebar
              title={translate('common.say-hi', { name: userName ?? '' })}
              links={sidebarItems.map((link) => ({ ...link, isActive: href?.includes(link.href) }))}
            />

          </div>
        </div>
        <div className={`block pb-5 ${href?.includes('project-builder') ?"xl:hidden":"lg:hidden"}`}> 
          <Select
            value={href}
            className="w-full"
            onChange={(selectedHref) => {
              window.location.href = selectedHref;
            }}
            options={sidebarItems.map(({ name, href }) => ({
              name,
              value: href,
            }))}
          />
        </div>
        <div className={`box-border min-h-[unset] w-full grow bg-[#FFFFFF] 2xl:min-h-[unset] min-w-0 ${href !== '/profile-settings' && 'md:pb-7'} ${href?.includes('project-builder')?"px-4 md:px-5 2xl:px-8":"px-4 md:px-5 lg:px-12 "}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
